export const categories = [
  {
    id: 'life',
    name: '生活分享',
    slug: 'life',
    description: '记录日常点滴，分享生活感悟，发现平凡中的美好',
    icon: 'ri-heart-line',
    articleCount: 128,
    coverImage: 'https://readdy.ai/api/search-image?query=warm%20cozy%20home%20interior%20with%20soft%20natural%20lighting%2C%20books%20and%20plants%20on%20wooden%20table%2C%20minimalist%20lifestyle%20photography%2C%20cream%20and%20beige%20tones%2C%20peaceful%20atmosphere%2C%20editorial%20style%20with%20gentle%20shadows%2C%20organic%20composition&width=800&height=500&seq=cat-life-01&orientation=landscape'
  },
  {
    id: 'emotion',
    name: '情感交流',
    slug: 'emotion',
    description: '倾诉心声，寻找共鸣，用文字温暖彼此的心灵',
    icon: 'ri-chat-heart-line',
    articleCount: 96,
    coverImage: 'https://readdy.ai/api/search-image?query=two%20people%20sitting%20on%20park%20bench%20during%20sunset%2C%20warm%20golden%20light%2C%20soft%20bokeh%20background%2C%20emotional%20connection%2C%20gentle%20autumn%20atmosphere%2C%20cinematic%20photography%20with%20lens%20flare%2C%20peaceful%20and%20intimate%20mood&width=800&height=500&seq=cat-emotion-01&orientation=landscape'
  },
  {
    id: 'travel',
    name: '旅行探索',
    slug: 'travel',
    description: '走遍山川湖海，分享旅途故事与攻略心得',
    icon: 'ri-earth-line',
    articleCount: 85,
    coverImage: 'https://readdy.ai/api/search-image?query=aerial%20view%20of%20misty%20mountain%20landscape%20with%20winding%20road%2C%20soft%20morning%20fog%2C%20warm%20sunrise%20light%2C%20layered%20hills%20in%20distance%2C%20nature%20adventure%2C%20peaceful%20and%20expansive%2C%20travel%20photography%20with%20atmospheric%20mood&width=800&height=500&seq=cat-travel-01&orientation=landscape'
  },
  {
    id: 'food',
    name: '美食天地',
    slug: 'food',
    description: '探索舌尖上的美味，从家常菜到各地风味',
    icon: 'ri-restaurant-line',
    articleCount: 112,
    coverImage: 'https://readdy.ai/api/search-image?query=beautifully%20plated%20home%20cooked%20meal%20on%20wooden%20table%2C%20steam%20rising%20from%20fresh%20dishes%2C%20warm%20kitchen%20lighting%2C%20herbs%20and%20ingredients%20scattered%20artfully%2C%20cozy%20dining%20atmosphere%2C%20food%20photography%20with%20soft%20natural%20light%2C%20rustic%20elegance&width=800&height=500&seq=cat-food-01&orientation=landscape'
  },
  {
    id: 'tech',
    name: '科技数码',
    slug: 'tech',
    description: '关注科技前沿，分享数码产品体验与技巧',
    icon: 'ri-smartphone-line',
    articleCount: 73,
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20workspace%20with%20laptop%20and%20smartphone%2C%20clean%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20plants%20and%20coffee%20cup%2C%20productive%20atmosphere%2C%20editorial%20tech%20photography%2C%20soft%20shadows%20and%20neutral%20background&width=800&height=500&seq=cat-tech-01&orientation=landscape'
  },
  {
    id: 'reading',
    name: '读书学习',
    slug: 'reading',
    description: '以书会友，在阅读中成长，分享知识与见解',
    icon: 'ri-book-open-line',
    articleCount: 67,
    coverImage: 'https://readdy.ai/api/search-image?query=stack%20of%20books%20on%20wooden%20desk%20beside%20warm%20reading%20lamp%2C%20cozy%20library%20corner%20with%20armchair%2C%20soft%20glowing%20light%2C%20intellectual%20atmosphere%2C%20vintage%20aesthetic%20with%20warm%20wood%20tones%2C%20peaceful%20study%20environment&width=800&height=500&seq=cat-reading-01&orientation=landscape'
  },
  {
    id: 'photography',
    name: '摄影艺术',
    slug: 'photography',
    description: '用镜头捕捉光影，分享摄影技巧与视觉故事',
    icon: 'ri-camera-line',
    articleCount: 59,
    coverImage: 'https://readdy.ai/api/search-image?query=vintage%20camera%20on%20wooden%20surface%20with%20photographs%20scattered%2C%20warm%20sunlight%20streaming%20through%20window%2C%20artistic%20composition%2C%20cream%20and%20sepia%20tones%2C%20creative%20photography%20studio%20atmosphere%2C%20soft%20shadows%20and%20textured%20background&width=800&height=500&seq=cat-photo-01&orientation=landscape'
  },
  {
    id: 'sports',
    name: '运动健康',
    slug: 'sports',
    description: '保持活力，分享运动健身经验与健康生活方式',
    icon: 'ri-run-line',
    articleCount: 54,
    coverImage: 'https://readdy.ai/api/search-image?query=person%20jogging%20on%20tree%20lined%20park%20path%20during%20golden%20hour%2C%20soft%20warm%20sunlight%2C%20active%20lifestyle%2C%20green%20nature%20surroundings%2C%20health%20and%20fitness%2C%20peaceful%20morning%20atmosphere%2C%20cinematic%20photography%20with%20motion%20blur&width=800&height=500&seq=cat-sports-01&orientation=landscape'
  }
];

export const articles = [
  {
    id: 'article-1',
    title: '在一个温暖的午后,我学会了与生活和解',
    slug: 'warm-afternoon-life-reconciliation',
    categoryId: 'life',
    categoryName: '生活分享',
    author: '微风轻语',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20cream%20background%2C%20simple%20line%20illustration%20style%2C%20friendly%20expression%2C%20clean%20design&width=100&height=100&seq=avatar-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=warm%20afternoon%20sunlight%20streaming%20through%20curtains%20into%20cozy%20living%20room%2C%20cat%20sleeping%20on%20sofa%2C%20book%20and%20tea%20on%20coffee%20table%2C%20peaceful%20domestic%20scene%2C%20soft%20golden%20light%2C%20minimalist%20interior%20with%20plants%2C%20serene%20atmosphere&width=1200&height=600&seq=article-01&orientation=landscape',
    summary: '生活不需要完美,只需要真实。在那些看似平凡的日子里,藏着最动人的温暖。让我们一起学会欣赏每个当下。',
    content: `<p>从前,我总是追求生活的完美。每个周末都要安排得满满的,生怕浪费一分一秒。直到那个午后的阳光透过窗帘洒在地板上,猫咪慵懒地躺在脚边打着呼噜,我才突然明白——生活最美的时刻,往往就在这些不经意的瞬间。</p><p>我泡了一杯茶,翻开了一本买了好久却一直没时间看的书。窗外偶尔传来几声鸟鸣,时间仿佛在这一刻慢了下来。不需要赶着去哪里,不需要完成什么任务,就这样安静地和自己待着。</p><p>有人说,和解就是不再和自己较劲。我深以为然。我们总是在追逐更好的未来,却忘了当下的每一刻也是曾经期待的未来。那个午后,我第一次真切地感受到了"此刻即所有"。</p><p>从那以后,我学会了给生活留白。不再把时间表排得密不透风,而是刻意留出一些无所事事的时光。在这些空白里,我重新发现了生活的乐趣——做一顿简单的晚餐,在阳台上看夕阳,或者只是静静地发呆。</p><p>也许我们都该学会这样:在快节奏的世界里,找到属于自己的慢时光。不是逃避,而是给灵魂一个喘息的机会。</p>`,
    publishedAt: '2026-08-05',
    readCount: 3280,
    likeCount: 562,
    commentCount: 89,
    tags: ['生活感悟', '慢生活', '心灵成长']
  },
  {
    id: 'article-2',
    title: '那些年,我们一起走过的老街巷',
    slug: 'old-streets-we-walked-together',
    categoryId: 'travel',
    categoryName: '旅行探索',
    author: '行走的云',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20beige%20background%2C%20simple%20illustration%20style%2C%20adventurous%20spirit%2C%20clean%20design&width=100&height=100&seq=avatar-02&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=ancient%20narrow%20alleyway%20in%20old%20Chinese%20town%2C%20stone%20path%20with%20moss%2C%20traditional%20wooden%20doors%20and%20red%20lanterns%2C%20warm%20afternoon%20sunlight%20casting%20long%20shadows%2C%20nostalgic%20atmosphere%2C%20cultural%20heritage%2C%20soft%20earthy%20tones&width=1200&height=600&seq=article-02&orientation=landscape',
    summary: '每一条老街都有它的故事。石板路上的青苔,墙角的野花,还有那些记忆中飘散的炊烟味道,都是城市最珍贵的记忆。',
    content: `<p>周末,我又回到了那条老街。青石板的路面被岁月打磨得光滑发亮,踩上去有一种踏实的质感。两旁的木门有些已经斑驳,但依然静静地伫立着,像是在诉说着什么。</p><p>记得小时候,这条街可热闹了。清晨有卖豆腐脑的吆喝声,中午飘来各家各户的饭菜香,傍晚则是孩子们追逐嬉闹的欢笑声。那时的我们,在这条街上度过了整个童年。</p><p>如今再走在这条街上,虽然很多老邻居已经搬走了,但那股熟悉的气息还在。墙角的青苔更厚了,那棵老槐树也更高了。几个老人坐在门口晒太阳,有一搭没一搭地聊着天。时光在这里仿佛走得特别慢。</p><p>我拿出相机,拍下了那些被忽略的细节——门环上的铜绿、窗棂上的雕花、还有那只慵懒的橘猫。这些看似普通的画面,却承载着满满的回忆。</p><p>或许有一天,这条老街也会被现代化的脚步淹没。但在我心里,它永远是那个充满温度的地方。</p>`,
    publishedAt: '2026-08-03',
    readCount: 4560,
    likeCount: 782,
    commentCount: 134,
    tags: ['老街记忆', '城市漫步', '怀旧', '摄影']
  },
  {
    id: 'article-3',
    title: '妈妈的拿手菜:那一碗热腾腾的红烧肉',
    slug: 'moms-braised-pork-belly',
    categoryId: 'food',
    categoryName: '美食天地',
    author: '厨房小厨娘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20peach%20background%2C%20simple%20illustration%20style%2C%20friendly%20chef%2C%20clean%20design&width=100&height=100&seq=avatar-03&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=delicious%20braised%20pork%20belly%20in%20clay%20pot%20with%20steam%20rising%2C%20dark%20glossy%20sauce%2C%20garnished%20with%20green%20onions%2C%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20home%20cooking%20aesthetic%2C%20comfort%20food%20photography%20with%20appetizing%20textures&width=1200&height=600&seq=article-03&orientation=landscape',
    summary: '每个人心中都有一道妈妈的味道。对我来说,就是那碗色泽红亮、肥而不腻的红烧肉。今天把这份温暖分享给大家。',
    content: `<p>说起红烧肉,很多人都会想到"外婆家"的味道。而对我来说,那是妈妈厨房里飘出来的香气,是我整个童年的底色。</p><p>妈妈做红烧肉,用的是最传统的方法。五花肉一定要选三肥两瘦的,切成方方正正的块。先在冷水里焯一下,去掉血水和腥味。然后最关键的一步——炒糖色。妈妈总说:"糖色炒好了,这道菜就成功了一半。"</p><p>看着白糖在锅里慢慢融化,变成琥珀色,再变成枣红色,然后迅速把焯好水的五花肉倒进去翻炒,肉块立刻裹上了一层漂亮的焦糖色。接着加入八角、桂皮、香叶,还有几片姜,倒入热水没过肉,大火烧开后转小火慢炖。</p><p>炖的过程中,厨房里弥漫着一种让人无法抗拒的香气。大概一个小时后,汤汁收得差不多了,撒上一把葱花,一碗色泽红亮、肥而不腻的红烧肉就出锅了。</p><p>夹起一块放进嘴里,肉皮Q弹,肥肉入口即化,瘦肉酥烂入味。配上一碗白米饭,简直是最朴素也最奢侈的享受。所谓家的味道,大概就是这样吧。</p>`,
    publishedAt: '2026-08-01',
    readCount: 5230,
    likeCount: 915,
    commentCount: 178,
    tags: ['家常菜', '红烧肉', '妈妈的味道', '美食教程']
  },
  {
    id: 'article-4',
    title: '在孤独中,我找到了更好的自己',
    slug: 'finding-better-self-in-solitude',
    categoryId: 'emotion',
    categoryName: '情感交流',
    author: '深海里的鱼',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20gray%20background%2C%20simple%20illustration%20style%2C%20thoughtful%20expression%2C%20clean%20design&width=100&height=100&seq=avatar-04&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=person%20sitting%20alone%20by%20window%20during%20rain%2C%20warm%20indoor%20lighting%2C%20raindrops%20on%20glass%2C%20cozy%20atmosphere%2C%20contemplative%20mood%2C%20soft%20focus%2C%20emotional%20photography%20with%20introspective%20tone&width=1200&height=600&seq=article-04&orientation=landscape',
    summary: '曾经害怕孤独,如今享受独处。孤独不是被世界抛弃,而是和自己深度对话的最好时机。',
    content: `<p>曾经的我很害怕一个人。一个人吃饭觉得尴尬,一个人看电影觉得奇怪,一个人逛街觉得无所适从。好像一个人就意味着不合群,意味着被世界遗忘。</p><p>直到有一次,因为工作关系不得不独自去一个陌生的城市生活了三个月。起初简直度日如年——没有人说话,没有朋友聚会,周末只能自己待在出租屋里。但慢慢地,我开始学着和自己相处。</p><p>一个人去探访城市的角落,发现了许多藏在巷子里的咖啡馆和书店。一个人在公园里散步,观察那些来来往往的人。一个人在深夜里写下自己的心情,那些平时没时间思考的问题,终于有了答案。</p><p>孤独给了我一个机会——一个和自己独处的机会。在那些安静的时刻里,我开始真正了解自己喜欢什么,想要什么,害怕什么。原来我比自己想象的更加丰富和有趣。</p><p>现在我依然享受社交的快乐,但也不再害怕独处的时光。因为我们终究要学会和自己好好相处,这大概是人生最重要的一课。</p>`,
    publishedAt: '2026-07-28',
    readCount: 6780,
    likeCount: 1234,
    commentCount: 256,
    tags: ['孤独', '自我成长', '情感治愈', '独处']
  },
  {
    id: 'article-5',
    title: '数码极简:如何用更少的设备过更高效的生活',
    slug: 'digital-minimalism-efficient-life',
    categoryId: 'tech',
    categoryName: '科技数码',
    author: '科技观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20cream%20background%2C%20simple%20illustration%20style%2C%20modern%20tech%20enthusiast%2C%20clean%20design&width=100&height=100&seq=avatar-05&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=minimalist%20desk%20setup%20with%20single%20laptop%20and%20notebook%2C%20clean%20workspace%2C%20natural%20light%20from%20window%2C%20small%20plant%20and%20coffee%20cup%2C%20cable%20free%20environment%2C%20calm%20productive%20atmosphere%2C%20modern%20lifestyle%20photography&width=1200&height=600&seq=article-05&orientation=landscape',
    summary: '被各种电子设备包围的我们,真的需要这么多吗?分享我的数码极简之路,用更少的设备,过更高效的生活。',
    content: `<p>一年前的某天,我数了数自己的电子设备:两台手机、一台平板、一台笔记本、一台台式机、智能手表、无线耳机、电子阅读器...我突然意识到,我拥有的设备越多,注意力就越分散。</p><p>于是我开始了数码极简之旅。第一步是清理——把所有设备摊开,诚实地问自己:哪些是真正需要的?哪些只是一时冲动买的?最后我只留下了一台手机、一台笔记本和一副耳机。</p><p>第二步是整合。以前我用十几个App管理生活,现在精简到五个:日历、笔记、任务管理、阅读和通讯。很多人觉得不可思议,但事实上,少了那些花里胡哨的工具,我的效率反而提高了。</p><p>第三步是建立边界。我设置了严格的使用规则:早上起床后一小时内不碰手机,晚上九点以后关闭所有通知,周末尽量只用电脑处理需要的事务。这些规则让我的生活找回了节奏感。</p><p>数码极简不是反科技,而是让科技回归工具的本质。当我不再被设备控制,反而能更好地利用它们。一年下来,我的睡眠质量提高了,注意力更集中了,甚至多了很多时间去读书和运动。</p>`,
    publishedAt: '2026-07-25',
    readCount: 3890,
    likeCount: 678,
    commentCount: 112,
    tags: ['数码极简', '效率提升', '生活方式', '数字生活']
  },
  {
    id: 'article-6',
    title: '读完这五本书,我重新理解了这个世界',
    slug: 'five-books-changed-my-worldview',
    categoryId: 'reading',
    categoryName: '读书学习',
    author: '书海拾贝',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20sand%20background%2C%20simple%20illustration%20style%2C%20book%20lover%2C%20clean%20design&width=100&height=100&seq=avatar-06&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=five%20beautifully%20bound%20books%20arranged%20on%20wooden%20table%2C%20warm%20reading%20lamp%20glow%2C%20reading%20glasses%20and%20cup%20of%20tea%2C%20cozy%20library%20corner%2C%20intellectual%20atmosphere%2C%20soft%20natural%20light%2C%20literary%20aesthetic%20photography&width=1200&height=600&seq=article-06&orientation=landscape',
    summary: '有些书读完就忘了,有些书却能改变你看世界的方式。推荐五本让我重新思考生活的书,也许你也会喜欢。',
    content: `<p>阅读最大的魅力,在于它能让你用极低的成本,去体验另一种人生、另一种思考方式。过去一年,我读了不少书,其中有五本让我印象深刻,它们从不同角度重塑了我的世界观。</p><p>第一本是《人类简史》。尤瓦尔·赫拉利用宏大的视角讲述了人类如何从一个不起眼的物种变成了地球的主宰。读完最大的感受是:很多我们习以为常的社会规则和制度,其实都是"想象出来的秩序"。这个视角让我开始用更批判的眼光看待周遭。 </p><p>第二本是《思考,快与慢》。丹尼尔·卡尼曼用心理学实验揭示了人类思维的两种模式——快思考和慢思考。了解这些认知偏差后,我做决策时会更谨慎,不再轻易相信直觉做出的判断。</p><p>第三本是《平凡的世界》。虽然是一本小说,但路遥笔下那些在贫困中奋斗的普通人,让我深刻理解了什么是坚韧与尊严。每次遇到困难,都会想起孙少平在矿井下的身影。</p><p>第四本是《被讨厌的勇气》。阿德勒心理学认为,人的烦恼大多来自人际关系,而解决之道在于"课题分离"。这个观点让我从很多无谓的焦虑中解脱出来。</p><p>第五本是《深度工作》。在这个碎片化时代,能够长时间专注的能力越来越稀缺。这本书教会我如何保护自己的注意力,去做那些真正重要的事。</p>`,
    publishedAt: '2026-07-22',
    readCount: 4120,
    likeCount: 845,
    commentCount: 198,
    tags: ['读书推荐', '书单', '思维方式', '个人成长']
  },
  {
    id: 'article-7',
    title: '手机摄影入门:用光线讲好每一个故事',
    slug: 'mobile-photography-light-storytelling',
    categoryId: 'photography',
    categoryName: '摄影艺术',
    author: '光影捕手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20terracotta%20background%2C%20simple%20illustration%20style%2C%20photographer%2C%20clean%20design&width=100&height=100&seq=avatar-07&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=smartphone%20photography%20setup%20with%20natural%20light%20streaming%20through%20window%2C%20creative%20composition%20with%20shadows%20and%20textures%2C%20artistic%20photography%20tools%2C%20warm%20and%20airy%20atmosphere%2C%20minimalist%20aesthetic%2C%20professional%20mobile%20photography%20style&width=1200&height=600&seq=article-07&orientation=landscape',
    summary: '最好的相机,就是你手中的那一部。掌握光线的秘密,你也能用手机拍出令人惊艳的作品。',
    content: `<p>很多人觉得拍照一定要用专业的单反相机。但其实,现在手机的摄影能力已经足够强大,关键在于你如何运用光线和构图。</p><p>光线是摄影的灵魂。我拍照片的黄金时间是日出后一小时和日落前一小时,这时候的光线柔和而温暖,能给照片增加质感和层次。逆光拍摄可以创造出迷人的剪影效果,侧光则能突出物体的纹理和立体感。</p><p>构图方面,我常用"三分法"——把画面分成九宫格,把主体放在交叉点上。这能让照片更有视觉张力。另外,"引导线"也是一个好用的技巧,利用道路、栏杆、河流等线条引导观众的视线。</p><p>还有一个秘密:善用前景。在画面中加入一些前景元素,比如树叶、门框、窗户,可以增加照片的深度和故事感。就像你透过什么在看这个世界。</p><p>最重要的是,多拍多练。不要害怕拍得不好,每一张照片都是一次学习。慢慢地,你会发现自己的风格。</p>`,
    publishedAt: '2026-07-20',
    readCount: 2950,
    likeCount: 534,
    commentCount: 87,
    tags: ['手机摄影', '摄影技巧', '构图', '光线']
  },
  {
    id: 'article-8',
    title: '晨跑一年的改变:从气喘吁吁到跑完半马',
    slug: 'morning-run-one-year-transformation',
    categoryId: 'sports',
    categoryName: '运动健康',
    author: '奔跑的蜗牛',
    authorAvatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20olive%20background%2C%20simple%20illustration%20style%2C%20runner%2C%20clean%20design&width=100&height=100&seq=avatar-08&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=person%20running%20on%20tree%20lined%20path%20during%20sunrise%2C%20golden%20morning%20light%2C%20fitness%20and%20health%2C%20active%20lifestyle%2C%20nature%20surroundings%2C%20motivational%20atmosphere%2C%20sports%20photography%20with%20warm%20tones&width=1200&height=600&seq=article-08&orientation=landscape',
    summary: '一年前连跑一公里都气喘吁吁,如今已经完成了人生第一个半马。分享这段跑步之旅,希望能给想开始运动的你一些鼓励。',
    content: `<p>一年前的今天,我跑完800米后蹲在路边喘了五分钟。那时候的我体重超标,体检报告显示多项指标亮红灯。医生说:"你必须开始运动了。"</p><p>从那天起,我给自己定了一个小目标:每天跑一公里。不用快,但不能停。第一周简直是在煎熬——腿疼、气喘、浑身不舒服。但到了第二周,我发现跑完一公里不再那么难受了。</p><p>一个月后,我把目标提高到三公里。三个月后,我能轻松跑五公里了。变化不仅仅是身体上的——以前早上总是睡不醒,现在六点自然醒;以前下午总要喝咖啡提神,现在精力充沛一整天。</p><p>半年的时候,我报名了一个线上半程马拉松。训练计划很简单:每周跑四次,其中一次是长距离。从八公里开始,慢慢加到十二、十五、十八公里。最难忘的是第一次跑完十八公里那天——回家后直接倒在沙发上,但心里充满了成就感。</p><p>比赛那天,我用了两小时十五分钟完成了21公里。冲过终点线的那一刻,我差点哭出来。不是因为累,而是因为——原来我真的可以做到。这一年,跑步给我的不仅是健康的身体,更是对自己的信心。</p>`,
    publishedAt: '2026-07-18',
    readCount: 3650,
    likeCount: 723,
    commentCount: 145,
    tags: ['跑步', '运动健身', '半马', '健康生活']
  }
];

export const hotArticles = [
  articles[3], articles[2], articles[0], articles[5], articles[1], articles[7]
];

export const communityFeatures = [
  {
    id: 'feature-1',
    icon: 'ri-user-heart-line',
    title: '温暖社区',
    description: '这里没有戾气和争吵,只有真诚的交流和温暖的鼓励。每一位成员都是社区的重要一员。'
  },
  {
    id: 'feature-2',
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '严格的内容审核机制和个人信息保护,让你可以放心地分享自己的故事和观点。'
  },
  {
    id: 'feature-3',
    icon: 'ri-group-line',
    title: '兴趣小组',
    description: '加入你感兴趣的话题小组,和志同道合的人一起交流、学习和成长。'
  },
  {
    id: 'feature-4',
    icon: 'ri-message-3-line',
    title: '即时互动',
    description: '点赞、评论、私信,多种互动方式让你不错过任何一次温暖的交流。'
  },
  {
    id: 'feature-5',
    icon: 'ri-palette-line',
    title: '多元内容',
    description: '文章、图片、视频,丰富的内容形式让你的表达更加生动有趣。'
  },
  {
    id: 'feature-6',
    icon: 'ri-award-line',
    title: '优质创作者',
    description: '我们鼓励和扶持优质内容创作者,让你的好内容被更多人看到。'
  }
];

export const communityStats = [
  { label: '注册用户', value: '128,000+', icon: 'ri-user-line' },
  { label: '每日活跃', value: '35,000+', icon: 'ri-fire-line' },
  { label: '原创文章', value: '56,000+', icon: 'ri-article-line' },
  { label: '社区话题', value: '2,800+', icon: 'ri-chat-1-line' }
];

export const reputations = [
  {
    id: 'rep-1',
    avatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20cream%20background%2C%20simple%20illustration%20style%2C%20friendly%20young%20woman%2C%20clean%20design&width=120&height=120&seq=rep-avatar-01&orientation=squarish',
    name: '小桥流水',
    role: '社区资深用户',
    content: '加入海角社区两年了,这里就像我的第二个家。每次分享生活都能收到温暖的回应,也在这里认识了几个很好的朋友。真诚推荐给每一个想找个地方好好说话的人。',
    joinedAt: '2024年3月加入'
  },
  {
    id: 'rep-2',
    avatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20beige%20background%2C%20simple%20illustration%20style%2C%20friendly%20young%20man%2C%20clean%20design&width=120&height=120&seq=rep-avatar-02&orientation=squarish',
    name: '北方的风',
    role: '优质内容创作者',
    content: '作为一个喜欢写字的人,海角社区给了我一个很好的展示平台。编辑器的体验很棒,读者的互动也很及时。更重要的是,这里的氛围让我愿意持续创作。',
    joinedAt: '2024年6月加入'
  },
  {
    id: 'rep-3',
    avatar: 'https://readdy.ai/api/search-image?query=minimalist%20portrait%20avatar%20circle%20shape%2C%20warm%20peach%20background%2C%20simple%20illustration%20style%2C%20friendly%20middle%20aged%20woman%2C%20clean%20design&width=120&height=120&seq=rep-avatar-03&orientation=squarish',
    name: '花开花落',
    role: '美食板块活跃用户',
    content: '退休后朋友推荐来的,本来只是想看看,没想到一发不可收拾。在美食板块分享家常菜谱,收到了好多鼓励。现在每天都要上来看看,已经成为生活习惯了。',
    joinedAt: '2023年11月加入'
  }
];

export const aboutInfo = {
  brandName: '海角社区',
  brandSlogan: '连接你我的温暖交流平台',
  intro: '海角社区成立于2023年,是一个开放、包容的在线社交社区平台。我们致力于为来自各地的用户打造一个温暖、真实的交流空间,让每个人都能在这里分享生活、交流情感、结交朋友。',
  mission: '我们相信,在快节奏的现代生活中,每个人都渴望一个可以真诚交流的地方。海角社区的使命就是成为这样一个"精神角落"——没有喧嚣和浮躁,只有温暖的对话和真实的连接。',
  vision: '成为中文互联网最具温度的社区平台,让亿万用户在海角找到归属感。',
  values: [
    { title: '真诚', description: '我们鼓励真实表达,拒绝虚假和伪装。每一个故事都值得被认真对待。' },
    { title: '包容', description: '尊重每一种声音,接纳每一个不同的观点。多元让社区更加丰富。' },
    { title: '温暖', description: '用善意回应善意,让每一次交流都充满温度。这里没有冷嘲热讽。' },
    { title: '成长', description: '在分享中学习,在交流中进步。社区帮助每个人成为更好的自己。' }
  ],
  contact: {
    email: 'hello@haijiao.community',
    wechat: '海角社区官方',
    address: '浙江省杭州市西湖区文三路478号华星时代广场',
    workHours: '周一至周五 9:00 - 18:00'
  }
};

export const faqs = [
  {
    question: '海角社区是什么?',
    answer: '海角社区是一个开放、包容的在线社交社区平台,汇聚来自各地的用户分享生活、交流情感、结交朋友。无论你是想记录生活、分享经验,还是寻找志同道合的朋友,海角社区都欢迎你。'
  },
  {
    question: '如何注册海角社区账号?',
    answer: '点击页面右上角的"注册"按钮,填写你的手机号或邮箱地址,设置密码,完成验证后即可注册成功。整个过程只需两分钟。注册后你就可以发布文章、参与讨论、与其他用户互动。'
  },
  {
    question: '海角社区有哪些内容板块?',
    answer: '海角社区目前设有生活分享、情感交流、旅行探索、美食天地、科技数码、读书学习、摄影艺术、运动健康等多个内容板块,覆盖日常生活的方方面面。未来还会根据用户需求不断增加新的板块。'
  },
  {
    question: '在海角社区发布内容有什么规则?',
    answer: '我们鼓励原创、真实、有价值的内容分享。请遵守社区规范,不发布违法违规、低俗暴力、侵犯他人权益的内容。我们相信好的社区氛围需要大家共同维护。'
  },
  {
    question: '海角社区是否收费?',
    answer: '海角社区的基础功能完全免费,包括注册、浏览、发布文章、评论互动等。我们希望通过免费开放的平台,让更多人享受到社区交流的乐趣。'
  }
];